export const ConfirmModel = (props) => {
  return (
    <div className="modal modalTrash modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <h4 className="modal__body--title">{props.title}</h4>
            <p className="para">{props.message}</p>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button onClick={props.onReject} className="btn btn__white">
                {props.no ? props.no : "No"}
              </button>
              {props?.hideYes ? null : (
                <button onClick={props.onAccept} className="btn btn__primary">
                  {props.yes ? props.yes : "Yes"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
